var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRiskIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.46447 15.4651C5.40215 14.5274 6.67392 14.0006 8 14.0006H16C17.3261 14.0006 18.5979 14.5274 19.5355 15.4651C20.4732 16.4028 21 17.6745 21 19.0006V21.0006C21 21.5529 20.5523 22.0006 20 22.0006C19.4477 22.0006 19 21.5529 19 21.0006V19.0006C19 18.205 18.6839 17.4419 18.1213 16.8793C17.5587 16.3167 16.7956 16.0006 16 16.0006H8C7.20435 16.0006 6.44129 16.3167 5.87868 16.8793C5.31607 17.4419 5 18.205 5 19.0006V21.0006C5 21.5529 4.55228 22.0006 4 22.0006C3.44772 22.0006 3 21.5529 3 21.0006V19.0006C3 17.6745 3.52678 16.4028 4.46447 15.4651Z",
    fill: "#FCFCFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.00061C10.3431 4.00061 9 5.34376 9 7.00061C9 8.65746 10.3431 10.0006 12 10.0006C13.6569 10.0006 15 8.65746 15 7.00061C15 5.34376 13.6569 4.00061 12 4.00061ZM7 7.00061C7 4.23919 9.23858 2.00061 12 2.00061C14.7614 2.00061 17 4.23919 17 7.00061C17 9.76203 14.7614 12.0006 12 12.0006C9.23858 12.0006 7 9.76203 7 7.00061Z",
    fill: "#FCFCFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskIcon2);
export default __webpack_public_path__ + "static/media/risk-icon-2.86cbd3ea5a7dc4d67f0b0715a3071930.svg";
export { ForwardRef as ReactComponent };